/* eslint no-console:0 */
// import Immutable from 'immutable';

interface Logger {
  getState: Function;
  dispatch: Function;
}

export default ({ getState, dispatch }: Logger) => (next: Function) => (
  action: any
) => {
  console.group(action.type);
  console.log('prev state', getState());
  const returnValue = next(action);
  console.log('next state', getState());
  console.groupEnd();
  return returnValue;
};



// WEBPACK FOOTER //
// ./app/store/middleware/logger.ts